module.exports = __webpack_public_path__ + "static/media/flaviana.b46b43f0.png";